const urlRegex = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
const langUrlRegex = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
const hostnameRegExp = /^(https?:\/\/)?([^#?]+)/i;

export default {
    getDomain(hostName: string) {
        let reg = urlRegex;
        const name = hostName.split('.')?.slice(-1)?.[0];
        if (name.length > 4 || name === 'com' || name === 'org') {
            reg = langUrlRegex;
        }
        const res = hostName.match(reg);
        const domain = res ? res[0] : '';
        return domain;
    },

    getProtocolAndHostNameFromUrl(url: string) {
        if (hostnameRegExp.test(url)) {
            // 将匹配分组后在进行组合
            const matches = url.match(hostnameRegExp);
            if (matches) {
                const protocol = matches[1] || ''; // https和http 可能为空
                const hostname = matches[2]; // www.xxx.com
                return `${protocol}${hostname}`;
            }
        }
        return url;
    },
    getUrlParams(str?: string) {
        if (!str) {
            return;
        }
        if (str.indexOf('?') === -1) {
            return;
        }
        const o: any = {};
        const params = str.split('?');
        params.forEach((s, y) => {
            if (y > 0) {
                const arrs = s.split('&');
                arrs.forEach(element => {
                    const arr = element.split('=');
                    o[arr[0]] = arr[1];
                });
            }
        });
        return o;
    },
    removeUrlParams(url: string) {
        return url.split('?')[0].split('#')[0];
    },
    updateUrlParams(uri: string, key: string, value: string) {
        if (!value) {
            return uri;
        }
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        return uri + separator + key + '=' + value;
    },

    /**
     * 是否有 http 或者 https, 不含有默认加上 http://
     * useHashParam 是否使用hash加参数，前提条件是 当前链接没有hash
     */
    urlInsertParam(urlString: string, param: string, useHashParam = false) {
        urlString = urlString.indexOf('http') > -1 ? urlString : 'http://' + urlString;
        let { protocol, hostname, port, pathname, search, hash } = this.parseURL(urlString);
        if (useHashParam && !hash) {
            hash = `#${param}`;
        } else {
            search += search.indexOf('?') > -1 ? '&' : '?';
            search += param;
        }
        return `${protocol}//${hostname}${port ? port : ''}${pathname}${search}${hash}`;
    },

    isDebug() {
        return window.location.href.indexOf('debug=1') !== -1;
    },
    isLocal() {
        return (
            window.location.host.startsWith('localhost') ||
            !!window.location.port ||
            window.location.href.indexOf(`${import.meta.env.VITE_INSIGHT_SERVER_URL_NO_PORT}`) !==
                -1
        );
    },
    isDev() {
        return window.location.host.startsWith('dev.ptmind.');
    },
    isProduction() {
        return import.meta.env.MODE === 'production';
    },
    isHttp() {
        return /^http:\/\//.test(window.location.href);
    },
    isHeatmap() {
        return window.location.href.indexOf('pagescene/heatmap') !== -1;
    },
    openUrlUseATag(overlayUrl: string) {
        const a = document.createElement('a');
        a.href = overlayUrl;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
    parseURL(urlString: string) {
        try {
            const urlObj = new URL(urlString);
            return urlObj;
        } catch (e) {
            const urlRegex =
                /^(?:([a-z]+):)?(\/\/(?:([^\/:@]+)(?::([^\/:@]+))?@)?([^\/?#:]+)(?::(\d+))?)?(\/[^?#]*)?(?:\?([^#]*))?(?:#(.*))?$/i;
            const match = urlString.match(urlRegex);
            return {
                protocol: match?.[1] || '',
                hostname: match?.[5] || '',
                port: match?.[6] || '',
                pathname: match?.[7] || '',
                search: match?.[8] ? '?' + match?.[8] : '',
                hash: match?.[9] ? '#' + match?.[9] : ''
            };
        }
    }
};
